import axios from 'axios'

const instance = axios.create({
   // Для локального стенда: REACT_APP_API_URL=http://localhost:4444/
   baseURL: process.env.REACT_APP_API_URL || 'https://api.platform.english-loom.com/'
})

instance.interceptors.request.use((config) => {
   config.headers.Authorization = window.localStorage.getItem('token')

   return config
})

export default instance